import { render, staticRenderFns } from "./MitAppMenu.vue?vue&type=template&id=44f62427&scoped=true"
import script from "./MitAppMenu.vue?vue&type=script&lang=js"
export * from "./MitAppMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f62427",
  null
  
)

export default component.exports